// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-audio[data-v-6c61b790] {\n  margin-top: 27px;\n}\n.editor-audio .editor-text[data-v-6c61b790] {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  color: #07354a;\n}\n.editor-audio .uploader[data-v-6c61b790] {\n  margin-top: 24px;\n}", ""]);
// Exports
module.exports = exports;
